import { render, staticRenderFns } from "./bannerSelector.vue?vue&type=template&id=28320180"
import script from "./bannerSelector.vue?vue&type=script&lang=js"
export * from "./bannerSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports